import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Article } from '../models/article';
import { SapArticle } from '../models/sap-article';
import { UomSap } from '../models/uom-sap';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http:HttpClient) { }

  async getArticles() : Promise<Article[]> {
    return this.http.get<Article[]>('/api/article')
      .toPromise();
  }

  async getUoms() : Promise<UomSap[]> {
    return this.http.get<UomSap[]>('/api/uoms-sap')
      .toPromise();
  }

  async getArticlesSap(dbname, type = 'SellItem') : Promise<SapArticle[]> {
    return this.http.post<SapArticle[]>('/api/articles-sap', {dbname: dbname, type: type})
      .toPromise();
  }

  async postArticle(article:Article) : Promise<Article> {
    return this.http.post<Article>('/api/article', article)
      .toPromise();
  }

  async getArticle(id:Number) : Promise<Article> {
    return this.http.get<Article>('/api/article/' + id)
      .toPromise();
  }
  
  async putArticle(article:Article) : Promise<Article> {
    return this.http.post<Article>('/api/article/' + article.id + '/edit', article)
      .toPromise();
  }
  
  async deleteArticle(article:Article) : Promise<void> {
    return this.http.get<void>('/api/article/' + article.id + '/delete')
      .toPromise();
  }
}
